class Download {

  constructor() {
    this.download();
  }

  download() {
    (function ($) {

      $('.ajax-download-file').on('click', function (e) {
        $(this).parent().siblings('.download-file-modal').addClass('show');
      });

      $('.download-file-button').on('click', function (e) {

        if (e.target === this || $(e.target).hasClass('download-single-file-thumbnail') || $(e.target).parent().hasClass('download-single-file-thumbnail') || $(e.target).hasClass('download-single-file-content') || $(e.target).parent().hasClass('download-single-file-content')) {
          let current = $(this)

          $.ajax({
            type: 'POST',
            url: variables.ajax_url,
            dataType: 'json',
            data: {
              action: 'download_file',
              file: $(this).attr('data-file'),
              firstname: $(this).closest('form').find('input[name="firstname"]').val(),
              lastname: $(this).closest('form').find('input[name="lastname"]').val(),
              email: $(this).closest('form').find('input[name="email"]').val(),
              download_form_gdpr_checkbox: $(this).closest('form').find('input[name="download_form_gdpr_checkbox"]').prop('checked') == true,
            },
            success: function (data) {
              if (data.type == 'error') {
                $(current).closest('.ajax-download-file').find('.download-file-modal:not(.show)').addClass('show')
              } else if (data.type == 'success') {
                $('.download-file-modal').removeClass('show')

                window.location = data.file_url
              }
            }
          });
        }
      });
    }(jQuery));
  }
}

export default Download;
